import React, { useState } from "react";
import { TextField, Typography, Box, Button } from "@mui/material";
import { TitleText } from "../../components/common/TitleText";
import { addDoc, collection } from "firebase/firestore";
import { firestore } from "../../firebase";
import { useSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';

const SubscribeRedesign = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");

  function ValidateEmail(inputEmail) {
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (inputEmail.match(validRegex)) {
      return true;
    } else {
      return false;
    }
  }

  const addSubscriber = async () => {
    try {
      ValidateEmail(email);

      if (ValidateEmail(email)) {
        const docRef = await addDoc(collection(firestore, "subscribers"), {
          email: email,
          date: new Date().toLocaleString(),
        });
        setEmail("");
        enqueueSnackbar("Subscribe Successfully...!!!", {
          variant: "success",
          autoHideDuration: 1500,
        });
        props.setSubscribeDialogState(false);
      } else {
        enqueueSnackbar("Pleae add a valid email", {
          variant: "info",
          autoHideDuration: 1500,
        });
      }
    } catch (err) {
      // console.log(err);
    }
  };
  return (
    <div>
      <Box
        container
        sx={{
          marginTop: "10px",
          marginBottom: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          width: "30vw",
          borderRadius: "50px 50px 0 0",
        }}
      >
        <TitleText
          // sx={{ textAlign: "center" }}
          fontWeight="bold"
          variant="h5"
          component="h5"
        >
          Email Address
          <CloseIcon
            sx={{ cursor:'pointer', marginBottom:'-0.4rem',float:'right',}}
            onClick={props.onCloseIconClick} />
        </TitleText>
        <TextField
          id="outlined-basic"
          placeholder="Enter your email address"
          variant="outlined"
          size="normal"
          type="email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{
            marginTop: "1.5rem",
            backgroundColor: "white",
            borderRadius: "0px 0px 0px 0px",
          }}
          // sx={{
          //   width: { md: "30%", sm: "40%", xs: "70%" },
          //   "&  ::placeholder": {
          //     textAlign: "center",
          //     fontSize: { md: "1.2rem", sm: "1.2rem", xs: "0.8rem" },
          //   },
          //   "& input": {
          //     height: "1rem",
          //   },
          //   marginTop: "1rem",
          // }}
        />

        <Button
          sx={{
            background: "#131313",
            color: "white",
            padding: "1rem 2.5rem",
            borderRadius: "0",
            marginTop: "1.5rem",
            border: "2px solid transparent",
            ":hover": {
              background: "white",
              color: "#131313",
              border: "2px solid black",
              boxSizing: "border-box",
            },
          }}
          onClick={addSubscriber}
        >
          <Typography sx={{ fontWeight: "600", fontSize: ".9rem" }}>
            Submit
          </Typography>
        </Button>
      </Box>
    </div>
  );
};

export default SubscribeRedesign;
